<template>
  <div class="new-slide horizontal layout center center-justified">
    <div v-if="newPresentationGuideTextVisible" class="w-full h-full bg-base-0">
      <aha-lottie-player
        :animationData="require('@/assets/animations/new-slide-begin.json')"
        :autoPlay="true"
        :loop="true"
      />
    </div>
    <div v-if="newSlideGuideTextVisible" class="w-full h-full bg-base-0">
      <aha-lottie-player
        :animationData="require('@/assets/animations/new-slide.json')"
        :autoPlay="true"
        :loop="true"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  ...mapState({
    presentation: (state) => state.presentation,
    isNewPresentation: (state) => state.isNewPresentation,
  }),
  computed: {
    newPresentationGuideTextVisible() {
      return this.isNewPresentation && this.presentation.slides.every((s) => !s.type)
    },
    newSlideGuideTextVisible() {
      return !this.isNewPresentation && !this.$store.state.slideActive.type
    },
  },
}
</script>
